import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./core/services/store";
import ApiService from "./core/services/api.service";
import cookies from "js-cookie";
// import MockService from "./core/mock/mock.service";

Vue.config.productionTip = false;

// Rollbar
import Rollbar from "vue-rollbar";
Vue.use(Rollbar, {
    accessToken: "db1845ddb013402d9d2d20517fa8cd59",
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    environment: "production",
    payload: {
        client: {
            javascript: {
                code_version: "version-1",
            },
        },
    },
});

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "./core/plugins/vue-i18n";
import vuetify from "./core/plugins/vuetify";
import "./core/plugins/portal-vue";
import "./core/plugins/bootstrap-vue";
import "./core/plugins/perfect-scrollbar";
import "./core/plugins/highlight-js";
import "./core/plugins/inline-svg";
import "./core/plugins/apexcharts";
import "./core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";

// API service init
ApiService.init();

/**
 * SECTION - Router & middleware
 */
router.beforeEach((to, from, next) => {
    // Check getters
    const isPremium = store.getters["auth/isPremium"];
    const isAuthenticated = store.getters["auth/isAuthenticated"];

    /*
     * SECTION - Start Middleware
     */
    // CASE - Routes that require authentication
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // Check to see what we're doing
        if (!isAuthenticated) {
            store.dispatch("auth/signOut");
            next({ name: "login" });
        } else {
            // Set auth
            ApiService.setHeader();

            // Check for premium
            if (to.matched.some((record) => record.meta.requiresPremium)) {
                // console.log("This route requires premium");
                if (isPremium) {
                    next();
                } else {
                    next({
                        name: "dashboard",
                        params: {
                            propFlashMessages: "user_not_premium",
                        },
                    });
                }
            } else {
                next();
            }
        }

        // CASE - Routes that require you to NOT be authenticated
    } else if (to.matched.some((record) => record.meta.requiresNotAuth)) {
        // You're not authenticad
        if (!isAuthenticated) {
            next();
        } else {
            // Case: You're actually authenticated, so redirect to Dashboard
            next({ name: "dashboard" });
        }

        // CASE - Failsafe
    } else {
        next();
    }

    // Scroll page to top on every route change
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
});

// NOTE - Dispatching get ME before we initiate Vue so we can check to see if we're logged in or not
store.dispatch("auth/me").then(() => {
    // Initiate the Vue instance
    new Vue({
        router,
        store,
        i18n,
        vuetify,
        render: (h) => h(App),
    }).$mount("#app");
});
